import React from "react";

export const NotificationChanged = React.createContext(null);
